import React, { useEffect, useState } from 'react';
import JobTitleInput from './JobTitleInput';
import JobDescriptionInput from './JobDescriptionInput';
import FormField from '../../FormField';
import JobDetailInput from './JobDetailInput';
import { client, consoleLogInDev } from 'shared';
import { JobDetail, JobDetailValueWithOption } from 'models';
import { FormFieldProps } from '../../FormTypes';

export default function BusinessJobDetails({
    headline,
    comments,
    jobDetails,
}: {
    headline: FormFieldProps<string>;
    comments: FormFieldProps<string>;
    jobDetails: FormFieldProps<JobDetailValueWithOption[]>;
}) {
    const [details, setDetails] = useState<JobDetail[]>([]);
    const getJobDetails = () => {
        client('api/job-detail/').then(setDetails).catch(consoleLogInDev);
    };
    useEffect(getJobDetails, []);

    return (
        <>
            <JobTitleInput title={headline} business />
            {details.map((detail) => (
                <FormField title={detail.name} key={detail.id}>
                    <JobDetailInput detail={detail} jobDetails={jobDetails} />
                </FormField>
            ))}
            <JobDescriptionInput description={comments} business />
        </>
    );
}
